import { Lightbulb } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { CATEGORY_IMAGES, CATEGORY_PILL_COLORS } from "@/data/curatedContent";

const DIFFICULTY_LABELS: Record<string, {label: string;className: string;}> = {
  beginner: { label: "Easy Win", className: "bg-green-500/15 text-green-700 dark:text-green-400 border-green-500/30" },
  intermediate: { label: "Intermediate", className: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30" },
  advanced: { label: "Advanced", className: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/30" }
};

interface MostUsefulRailProps {
  orgIdeas?: Array<{title: string;description: string;category: string;difficulty: string;time_saved?: string;}>;
  onIdeaClick?: (idea: any) => void;
}

export function MostUsefulRail({ orgIdeas = [], onIdeaClick }: MostUsefulRailProps) {
  if (orgIdeas.length === 0) return null;

  return (
    <div style={{ marginBottom: 80 }} className="mb-[15px]">
      <h2
        className="text-foreground font-semibold"
        style={{ fontSize: 22, marginBottom: 24 }}>
        
        <div className="flex items-center gap-2">
          <Lightbulb className="h-5 w-5 text-primary" />
          Ideas based on your prompts
        </div>
      </h2>
      <div
        className="flex overflow-x-auto scrollbar-hide pb-0"
        style={{ gap: 24 }}>
        
        {orgIdeas.map((idea, i) => {
          const img = CATEGORY_IMAGES[idea.category];
          const pill = CATEGORY_PILL_COLORS[idea.category];
          return (
            <div
              key={`idea-${i}`}
              role="button"
              tabIndex={0}
              onClick={() => onIdeaClick?.(idea)}
              onKeyDown={(e) => e.key === "Enter" && onIdeaClick?.(idea)}
              className="shrink-0 cursor-pointer rounded-lg border border-border bg-card hover:border-primary/30 transition-colors overflow-hidden flex flex-col"
              style={{ width: 260, height: 240 }}>
              
              {img &&
              <div className="h-[100px] w-full overflow-hidden bg-muted">
                  <img
                  src={img}
                  alt={idea.category}
                  className="w-full h-full object-cover"
                  loading="lazy" />
                
                </div>
              }
              <div className="p-3 flex-1 flex flex-col">
                <h3
                  className="text-foreground font-semibold line-clamp-2"
                  style={{ fontSize: 15, lineHeight: "20px", marginBottom: 6 }}>
                  
                  {idea.title}
                </h3>
                {idea.time_saved &&
                <p className="text-muted-foreground" style={{ fontSize: 12, marginBottom: 6 }}>
                    ⏱ {idea.time_saved}
                  </p>
                }
                <div className="mt-auto flex items-center gap-2 flex-wrap">
                  {pill &&
                  <Badge variant="secondary" className={`text-xs ${pill.bg} ${pill.text} ${pill.border}`}>
                      {idea.category}
                    </Badge>
                  }
                  {DIFFICULTY_LABELS[idea.difficulty] &&
                  <Badge variant="secondary" className={`text-xs ${DIFFICULTY_LABELS[idea.difficulty].className}`}>
                      {DIFFICULTY_LABELS[idea.difficulty].label}
                    </Badge>
                  }
                </div>
              </div>
            </div>);

        })}
      </div>
    </div>);

}